module.exports = __webpack_public_path__ + "static/img/9.d18c268.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/9.png
// module id = 1TOh
// module chunks = 0